import React, { Fragment } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import TransportFactory from 'core-ui__transport';

import Core, { createStore } from 'block/core';
import Application from 'page/application';
import Home from 'page/home';
import Modal from 'block/modal';

import config from 'config';

const transportFactory = new TransportFactory(config.transport);
const transport = transportFactory.getClientInstance();

const store = createStore();
const mountNode = document.getElementById('app');

transportFactory
    .init()
    .then(() => {
        render((
            <Core transport={transport}>
                <Provider store={store} key="provider">
                    <Fragment>
                        <Application>
                            <Home />
                        </Application>
                        <Modal />
                    </Fragment>
                </Provider>
            </Core>
        ), mountNode);
    })
    .catch(console.error);



// WEBPACK FOOTER //
// ./src/index.js